import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'the_basis_of_the_harassment_select_all_that_apply'

export const dataPointDefinition = {
  retracedId: 'the_basis_of_the_harassment_select_all_that_apply',
  name: 'Please specify the basis of the harassment:',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RACE_ETHNIC_GROUP_SKIN_COLOR',
      text: 'Race / Ethnic Group / Skin Color',
      externalIds: [
        {
          id: 'hb-5--1-1x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RELIGION',
      text: 'Religion',
      externalIds: [
        {
          id: 'hb-5--1-2x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'POLITICAL_OPINION',
      text: 'Political Opinion',
      externalIds: [
        {
          id: 'hb-5--1-3x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NATIONAL_EXTRACTION',
      text: 'National Extraction',
      externalIds: [
        {
          id: 'wt-har-8x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SOCIAL_ORIGIN',
      text: 'Social Origin',
      externalIds: [
        {
          id: 'wt-har-9x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISABILITY',
      text: 'Disability',
      externalIds: [
        {
          id: 'hb-5--1-5x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
      text: 'HIV / AIDS Status (real or perceived)',
      externalIds: [
        {
          id: 'hb-5--1-6x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SEXUAL_ORIENTATION',
      text: 'Sexual Orientation',
      externalIds: [
        {
          id: 'hb-5--1-7x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'GENDER_IDENTITY',
      text: 'Gender Identity',
      externalIds: [
        {
          id: 'wt-har-10x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PREGNANCY_MATERNITY_STATUS',
      text: 'Pregnancy / Maternity Status',
      externalIds: [
        {
          id: 'hb-5--1-8x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MARITAL_STATUS',
      text: 'Marital Status',
      externalIds: [
        {
          id: 'wt-har-11x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'AGE',
      text: 'Age',
      externalIds: [
        {
          id: 'hb-5--1-9x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
      text: 'Nationality / Foreign Migrant Worker Status',
      externalIds: [
        {
          id: 'hb-5--1-10x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FAMILY_RESPONSIBILITIES',
      text: 'Family responsibilities',
      externalIds: [
        {
          id: 'wt-har-12x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'hb-5--1-11x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe what "Other" ground of harassment occurred:',
        externalIds: [
          {
            id: 'hb-5--1-11f',
            version: '1.5.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RACE_ETHNIC_GROUP_SKIN_COLOR',
                'RELIGION',
                'POLITICAL_OPINION',
                'NATIONAL_EXTRACTION',
                'SOCIAL_ORIGIN',
                'DISABILITY',
                'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
                'SEXUAL_ORIENTATION',
                'GENDER_IDENTITY',
                'PREGNANCY_MATERNITY_STATUS',
                'MARITAL_STATUS',
                'AGE',
                'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
                'FAMILY_RESPONSIBILITIES',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-har-7',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10220,
  sectionId: '2.2.5.5',
  impactArea: 'Harassment and Abuse',
  impactAreaId: 'HARRASSMENT_AND_ABUSE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
